import React, { useState, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
// utils
import { handleCatchError, handleAPIError } from 'utils/handleErrors';
import formatMoney from 'utils/formatMoney';

// components
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
import { ToastSuccess } from '../../../../components/alerts/toast';
// api
import { returnShipping } from '../../../api/Api-admin';

const ReturnShippingModal = ({ data = {}, isModalOpen = '', setIsModalOpen = '', setUpdatePage = '' }) => {
  // console.log('guia data:', data);
  // const counter = useRef(1);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);
  const handlerReturnShipping = async () => {
    setIsAddChargerLoader(true); // active loader in the button
    // console.log('se activo bt para devolver guia', (counter.current = +1));
    try {
      const response = await returnShipping(data.shipping_label_id);
      // console.log('return shipping response:', response);
      if (response.shipping_check) {
        ToastSuccess(`⭐ ${response.charge_statement}. Cargo de $${response.amount} aplicado al envío ${response.reference}.`);
        setUpdatePage(true);
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setIsModalOpen(false);
      setIsAddChargerLoader(false); // active loader in the button
    }
  };
  return (
    <>
      {/* Confirm Modal Start */}
      <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Modificar saldo del usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-semi-large mb-3 ">
            ¿Confirmas que deseas <strong className="px-1">reembolsar</strong>este envío?
          </div>
          <div className="text-alternate">{data?.razon_social}</div>
          <div className="text-alternate">{`${data?.shipping_code}`}</div>
          <div className="text-alternate">{`ID: ${data?.shipping_label_id}`}</div>
          {data.shipping_rates.insurance > 0 && (
            <div className="text-alternate">
              <span>SEGURO:</span>
              <strong className="text-alternate">{` $${formatMoney(data.shipping_rates.insurance)}`}</strong>
            </div>
          )}
          <div className="text-alternate">
            <span>GUÍA:</span>
            <strong className="text-success">{` $${formatMoney(data?.shipping_rates?.total)}`}</strong>
          </div>
          {data.shipping_rates.insurance > 0 && <span className="text-medium text-muted">* El costo del seguro no será reembolsado</span>}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button variant="outline-primary" onClick={() => setIsModalOpen(false)} style={{ height: '36px' }} className="me-2">
              Cancelar
            </Button>
            <ButtonRequest
              title="Si, Reembolsar"
              titleLoading="Cargando"
              handlerFn={handlerReturnShipping}
              // isButtonDisabled={isButtonDisabled}
              isButtonDisabled={isAddChargerLoader}
              isLoading={isAddChargerLoader}
            />
          </div>
        </Modal.Footer>
      </Modal>
      {/* Confirm Modal End */}
    </>
  );
};
export default ReturnShippingModal;
